import SwipeListItem from './SwipeListItem';
export default SwipeListItem;